import React from "react";
import Button from "./common/Button";

interface SessionTimeoutWarningProps {
  secondsRemaining: number;
  onContinue: () => void;
  onLogout: () => void;
}

const SessionTimeoutWarning: React.FC<SessionTimeoutWarningProps> = ({
  secondsRemaining,
  onContinue,
  onLogout,
}) => {
  const minutes = Math.floor(secondsRemaining / 60);
  const seconds = secondsRemaining % 60;

  return (
    <dialog className="modal modal-open">
      <div className="modal-box max-w-sm">
        <h3 className="text-lg font-semibold text-base-content mb-2">
          Session Expiring
        </h3>
        <p className="text-sm text-gray-600 dark:text-base-content/70 mb-4">
          Your session will expire due to inactivity in{" "}
          <span className="font-mono font-semibold text-red-600 dark:text-red-400">
            {minutes}:{seconds.toString().padStart(2, "0")}
          </span>
        </p>
        <div className="flex gap-3">
          <Button variant="primary" onClick={onContinue} className="flex-1">
            Continue Session
          </Button>
          <Button variant="secondary" onClick={onLogout} className="flex-1">
            Log Out
          </Button>
        </div>
      </div>
      <form method="dialog" className="modal-backdrop">
        <button type="button" onClick={onContinue}>
          close
        </button>
      </form>
    </dialog>
  );
};

export default SessionTimeoutWarning;
